import { Box, Button, Typography } from "@mui/material";
import { errorBoxStyle } from "./styled";

export const GenericError = ({ icon, header, subText, button, onButton }: {
  icon?: JSX.Element,
  header?: JSX.Element | string,
  subText?: JSX.Element | string,
  button?: JSX.Element | string
  onButton?: () => void,
}) => (<Box sx={errorBoxStyle}>
  {icon ?? icon}
  {
    header ?? typeof header === "string"
      ? <Typography
        variant={'h5'}
        sx={{
          textAlign: "center",
          fontWeight: "bold",
          fontSize: "16px",
          fontFamily: "ProximaNovaRegular",
          color: "#000000DE"
        }}>
        {header}
      </Typography>
      : header
  }
  {
    subText ?? typeof subText === "string"
      ? <Typography sx={{
        textAlign: "center",
        color: "red"
      }}>
        {subText}
      </Typography>
      : subText
  }
  {
    button ?? typeof button === "string"
      ? <Button variant="contained" sx={{
        textTransform: "none",
        backgroundColor: "#05294D",
        '&:hover': {
          backgroundColor: '#05294D',
        },
      }} onClick={() => {
        if (onButton) onButton()
      }}>
        {button}
      </Button>
      : button
  }
</Box>);